import { render, staticRenderFns } from "./MyHealth.vue?vue&type=template&id=13a73f69"
import script from "./MyHealth.vue?vue&type=script&lang=js"
export * from "./MyHealth.vue?vue&type=script&lang=js"
import style0 from "./MyHealth.vue?vue&type=style&index=0&id=13a73f69&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports